import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "product-price-details" }
const _hoisted_2 = { class: "fs-regular" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "d-none d-print-inline" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_6 = ["innerHTML"]

import {
  PropType,
  computed,
  ref,
  onMounted,
} from 'vue';
import { formatNumber } from '@/helpers';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import Product from '../../classes/Product';


export default /*#__PURE__*/_defineComponent({
  props: {
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
},
  emits: ['subs'],
  setup(__props, { emit }) {

const props = __props

library.add(faInfoCircle);




const countSub = ref(1);

const rowsPrices = computed(() => {
  const rows: Record<any, unknown>[] = [];

  if (props.product.priceIsDouble) {
    rows.push({
      label: 'Preis pro kWh HT',
      value: `${props.product.getPriceFormatted('workingPriceHt')}&thinsp;Cent&nbsp;`,
    });
    rows.push({
      label: 'Preis pro kWh NT',
      value: `${props.product.getPriceFormatted('workingPriceNt')}&thinsp;Cent&nbsp;`,
    });
  } else {
    rows.push({
      label: 'Preis pro kWh',
      value: `${props.product.getPriceFormatted('workingPrice')}&thinsp;Cent&nbsp;`,
    });
  }

  rows.push({
    label: 'Grundpreis pro Monat',
    value: `${props.product.getPriceFormatted('basePrice')}&thinsp;€`,
  });

  rows.push({
    label: '<b>Ihr Monatsabschlag</b>',
    value: `<b>${props.product.getPriceWithoutBonusFormatted('monthly')}&thinsp;€</b>`,
  });

  if (props.product.appliedBonuses.length) {
    rows.push({
      label: 'Gesamtpreis ohne Bonus',
      value: `${props.product.getPriceWithoutBonusFormatted('yearly')}&thinsp;€`,
    });

    props.product.appliedBonuses.forEach((bonus) => {
      rows.push({
        label: `<b class="color-primary">${bonus.name}</b>`,
        value: `${formatNumber(bonus.bonus_value, 2)}&thinsp;€`,
        info: bonus.info,
        sub: countSub.value,
      });

      countSub.value += 1;
    });

    rows.push({
      label: '<b>Gesamtpreis mit Bonus im ersten Jahr</b>',
      value: `${props.product.getPriceFormatted('yearly')}&thinsp;€`,
    });
  } else {
    rows.push({
      label: '<b>Gesamtpreis im ersten Jahr</b>',
      value: `<b>${props.product.getPriceFormatted('yearly')}&thinsp;€</b>`,
    });
  }

  rows.push({
    label: '<b>Ø Preis pro Monat (bei 12 Monaten)</b>',
    value: `<b>${props.product.getPriceFormatted('monthly')}&thinsp;€</b>`,
  });

  return rows;
});

onMounted(() => {
  const subs: { sub: number, info: string }[] = [];

  rowsPrices.value.forEach((row) => {
    if (row.info && row.sub) {
      subs.push({ sub: row.sub as number, info: row.info as string });
    }
  });

  emit('subs', subs);
});


return (_ctx: any,_cache: any) => {
  const _component_IoTooltip = _resolveComponent("IoTooltip")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rowsPrices), (row) => {
      return (_openBlock(), _createElementBlock("tr", {
        key: row.label
      }, [
        _createElementVNode("td", _hoisted_2, [
          _createElementVNode("span", {
            innerHTML: row.label
          }, null, 8, _hoisted_3),
          _createElementVNode("sup", _hoisted_4, _toDisplayString(row.sub), 1),
          _hoisted_5,
          (row.info)
            ? (_openBlock(), _createBlock(_component_IoTooltip, {
                key: 0,
                class: "color-primary d-print-none"
              }, {
                title: _withCtx(() => [
                  _createTextVNode(_toDisplayString(row.info), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(FontAwesomeIcon), { icon: "fa-light fa-info-circle" })
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", {
          class: "fs-regular",
          innerHTML: row.value
        }, null, 8, _hoisted_6)
      ]))
    }), 128))
  ]))
}
}

})